<template>
  <item-card>
    <template v-slot:title>
      <h3 class="text-lg leading-6 font-medium text-gray-900 dark:text-gray-300">
        Klienti
      </h3>
    </template>

    <template v-slot:content>
      
      <template v-if="customers.length > 0">

        <template v-for="(customer, index) in customers" :key="index">
          <ShowCustomer :customer="customer"/>
        </template>

      </template>

      <template v-else>
        <div class="w-full">
          <p class="text-center text-lg text-gray-400 mb-3">Kontaktam nav pievienoti klienti</p>
        </div>
      </template>

    </template>
  </item-card>
</template>

<script>
import { mapGetters } from 'vuex'
import ItemCard from "@/components/Components/ItemCard"
import ShowCustomer from "@/components/Customer/Contact/Customers/ShowCustomer"

export default {
  name: "AllCustomers",
  components: {
    ItemCard,
    ShowCustomer,
  },
  props: {
    customers: {
      type: Object,
      required: true,
    }
  },
  computed: {
    ...mapGetters({
      customer: 'customer',
      formsForDisplay: 'formsForDisplay',
    })
  },
  methods: {
    showForm(formName){
      this.$store.dispatch('addFormForDisplay', formName)
    },
    displayForm(formName){
      return this.formsForDisplay.includes(formName)
    },
  }
}
</script>

<style>

</style>